import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthService} from '../../shared/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class LandlineService {

    constructor(protected http: HttpClient, private auth: AuthService) {
    }

    getHeaders() {
        const token = 'Bearer ' + this.auth.getToken();

        return new HttpHeaders({
            Authorization: token,
            'Content-Type': 'application/json'
        });
    }

    getProviders() {
        return this.http.get(environment.amenaEndpoint + 'master/service-providers-landline', {headers: this.getHeaders()});
    }
}
